import React, { useState, useEffect } from 'react';
import { collection, doc, getDoc, getDocs, orderBy, query, where } from "firebase/firestore";
import { FirebaseDB } from "firebase-config";

interface Option {
    id: string;
    enabled: boolean;
    required: boolean;
    name: string;
    requirements: string[];
    rolsCanAcces: string[];
}

interface EditOptionFormProps {
    option: Option;
    availableCategories: { id: string; name: string }[];
    onSave: (updatedOption: Option) => void;
    onClose: () => void;
}

export default function EditOptionForm({ option, onSave, onClose, availableCategories }: EditOptionFormProps) {
    //console.log("Prop availableCategories recibida en el modal:", availableCategories);

    const [formData, setFormData] = useState({
        ...option,
        rolsCanAccess: Array.isArray(option.rolsCanAcces) ? option.rolsCanAcces : [],
    });
    const [availableRoles, setAvailableRoles] = useState<{ id: string; label: string }[]>([]);
    //const [availableCategories, setAvailableCategories] = useState<{ id: string; name: string }[]>([]);
    //console.log("datos de la categoria:", option);
    //console.log("Requisitos de la categoria especifica:", formData.requirements);
    //console.log("Toda la DAta options en modal:", availableCategories);
    


    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type, checked } = e.target as HTMLInputElement;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSave = () => {
        onSave({
            ...formData,
            ...formData,
            enabled: formData.enabled,
        });
        onClose();
    };

    const getRolesList = async () => {
        try {
            const displaySnapshot = await getDoc(doc(FirebaseDB, "roles", "_base_"));
            //console.log("displaySnapshot", displaySnapshot.data());
            const data = displaySnapshot.data();
            if (data && data.rolesList) {
                const roles = data.rolesList.map((role: { id: string; label: string }) => ({
                    id: role.id,
                    label: role.label,
                }));
                //console.log("Roles (id y label):", roles);
                return roles;
            }
        } catch (error) {
            //console.error("Error al obtener los roles:", error);
        }

        return [];
    };



    useEffect(() => {
        const fetchRoles = async () => {
            const roles = await getRolesList();
            //console.log("Roles disponibles:", roles);
            setAvailableRoles(roles);

            // Sincronizar roles seleccionados con los disponibles usando id
            const filteredRoles = roles
                .filter((role: { id: string; }) => formData.rolsCanAccess.includes(role.id))
                .map((role: { id: any; }) => role.id); // Solo conservar los ids
            //console.log("Roles seleccionados sincronizados (ids):", filteredRoles);
            setFormData((prevFormData) => ({
                ...prevFormData,
                rolsCanAccess: filteredRoles,
            }));
        };

        fetchRoles();
    }, []);

    //const availableRoles = ['Admin', 'Editor', 'Viewer', 'Guest'];
    const handleRoleChange = (roleId: string) => {
        const updatedRoles = formData.rolsCanAccess.includes(roleId)
            ? formData.rolsCanAccess.filter((id) => id !== roleId) // Remove role if already selected
            : [...formData.rolsCanAccess, roleId]; // Add role if not selected
        setFormData({ ...formData, rolsCanAccess: updatedRoles });
    };
    const handleCategoryChange = (categoryId: string) => {
        const updatedRequirements = formData.requirements.includes(categoryId)
            ? formData.requirements.filter((id) => id !== categoryId) // Remove category if already selected
            : [...formData.requirements, categoryId]; // Add category if not selected
        setFormData({ ...formData, requirements: updatedRequirements });
    };


    return (
        <div className="modal">
            <div className="modal-content ">
                <h2 className='text-xl text-white font-semibold w-full border-b-2 p-5 bg-primary rounded-t-lg'>Configuración de la option {formData.name}</h2>
                <form className='p-5'>
                    <div className='flex flex-row justify-between mb-5 gap-x-10'>
                        <div className='flex flex-col w-full'>
                            <label className='font-semibold'>Nombre:</label>
                            <input
                                className='inputFormCat'
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                id='TextIputNameOptions'
                            />
                        </div>
                        <div className='flex '>
                            <label>Inactiva</label>
                            <div
                                className={`toggle mx-4 ${formData.enabled ? 'enabled' : 'disabled'}`}
                                onClick={() =>
                                    setFormData({
                                        ...formData,
                                        enabled: !formData.enabled,
                                    })
                                }
                            >
                                <div className="toggle-circle"></div>
                            </div>
                            <label>Activa</label>
                        </div>
                    </div>
                    <div>
                        <label className='font-semibold'>Selección de Roles:</label>
                        <div className="grid grid-cols-2 gap-4 roles-checkboxes mt-4">
                            {availableRoles.map((role) => (
                                <div key={role.id} className="flex items-center mb-2">
                                    <input
                                        type="checkbox"
                                        id={`role-${role.id}`}
                                        checked={formData.rolsCanAccess.includes(role.id)}
                                        onChange={() => handleRoleChange(role.id)}
                                    />
                                    <label htmlFor={`role-${role.id}`} className="ml-2">{role.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div>
                        <label className='font-semibold'>Requerimientos para la categoría:</label>
                        <div className="grid grid-cols-2 gap-4 categories-checkboxes mt-4">
                            {availableCategories.map((category) => (
                                <div key={category.id} className="flex items-center mb-2">
                                    <input
                                        type="checkbox"
                                        id={`category-${category.id}`}
                                        checked={formData.requirements.includes(category.id)}
                                        onChange={() => handleCategoryChange(category.id)}
                                    />
                                    <label htmlFor={`category-${category.id}`} className="ml-2">
                                        {category.name}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="modal-actions">
                        <button id='SaveConfigOptions' type="button" className='buttonGuardarModalSave' onClick={handleSave}>
                            Guardar
                        </button>
                        <button id='CancelConfigOptions' type="button" className='buttonGuardarModalCancel' onClick={onClose}>
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}